import React, { useEffect, useRef } from "react";

import "../styles/components/TableauEmbed.scss";

const TableauEmbed = () => {
    const vizRef = useRef(null);

    useEffect(() => {
        const divElement = vizRef.current;
        const vizElement = divElement.getElementsByTagName("object")[0];

        const scriptElement = document.createElement("script");
        scriptElement.src =
            "https://public.tableau.com/javascripts/api/viz_v1.js";
        vizElement.parentNode.insertBefore(scriptElement, vizElement);
    }, []);

    // For the moment the id it's hard-coded since this is an static component
    return (
        <div className="tableau ratio-16x9" id="viz1718827760958" ref={vizRef}>
            <noscript>
                <a href="/#" aria-label="tableau">
                    <img
                        alt=" "
                        src="https://public.tableau.com/static/images/St/StaffingMandateReport/StaffingMandateReport/1_rss.png"
                        className="border-0"
                    />
                </a>
            </noscript>
            <object className="tableauViz" style={{ display: "none" }}>
                <param
                    name="host_url"
                    value="https%3A%2F%2Fpublic.tableau.com%2F"
                />
                <param name="embed_code_version" value="3" />
                <param name="site_root" value="" />
                <param
                    name="name"
                    value="StaffingMandateReport/StaffingMandateReport"
                />
                <param name="tabs" value="yes" />
                <param name="toolbar" value="yes" />
                <param
                    name="static_image"
                    value="https://public.tableau.com/static/images/St/StaffingMandateReport/StaffingMandateReport/1.png"
                />
                <param name="animate_transition" value="yes" />
                <param name="display_static_image" value="yes" />
                <param name="display_spinner" value="yes" />
                <param name="display_overlay" value="yes" />
                <param name="display_count" value="yes" />
                <param name="language" value="en-US" />
            </object>
        </div>
    );
};

export default TableauEmbed;
